import { CSSObject } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { ENABLE_AUTHENTICATION_STEPS } from "../../types";

interface StyleProps {
  step?: ENABLE_AUTHENTICATION_STEPS;
  isSelectMethodStep?: boolean;
}

export const useStyles = ({ step, isSelectMethodStep }: StyleProps = {}) =>
  ({
    twoFaPage: {
      display: "flex",
      flexDirection: "column"
    },
    logoBlock: {
      display: "flex",
      padding: "16px 24px"
    },
    twoFaPageContainer: {
      alignSelf: "center",
      maxWidth:
        step === ENABLE_AUTHENTICATION_STEPS.SelectMethod ? "684px" : "448px",
      margin: "64px 24px 24px 24px",

      "@media (max-width: 1439px)": {
        margin: "24px"
      }
    },
    titleArea: {
      textAlign: "center",
      marginBottom: "32px"
    },
    contentArea: {
      textAlign: "center"
    },
    authenticatorQrBlock: {
      display: "flex",
      flexDirection: "column",
      marginTop: "16px"
    },
    otpContentContainer: {
      color: colors.textDark
    },
    innerTopContainer: {
      padding: "24px"
    },
    innerTopShared: { color: colors.textDark, wordBreak: "break-word" },
    innerTopTitle: {
      "& span": {
        fontWeight: "700"
      }
    },
    innerTopDescription: {
      margin: "4px 0 0"
    },
    borderFrame: {
      border: `1px solid ${colors.gray200}`,
      borderRadius: "12px"
    },
    authSetupActions: {
      display: "flex",
      justifyContent: "space-between",
      columnGap: "12px",
      marginTop: "16px"
    },
    innerBottom: {
      padding: "24px",
      borderTop: `1px solid ${colors.gray200}`
    },
    mainIconContainer: {
      "& > svg": {
        fontSize: isSelectMethodStep ? "200px" : "144px",

        "@media (max-width: 839px)": {
          fontSize: "144px"
        }
      }
    },
    radioGroup: {
      flexDirection: "row",
      flexWrap: "nowrap",

      "& > label": {
        flex: "1",
        alignSelf: "flex-start"
      },

      "@media (max-width: 839px)": {
        flexDirection: "column",
        flexWrap: "wrap",
        rowGap: "16px",

        "& > label": {
          flex: "unset",
          alignSelf: "unset"
        }
      }
    },
    authRadioLabel: {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      rowGap: "4px",
      marginTop: "-2px",
      marginBottom: "4px",

      "& > span": {
        display: "inline-block",
        marginRight: "10px"
      }
    },
    innerBottomSeparator: {
      background: colors.gray200,
      width: "1px",
      margin: "0 16px"
    },
    emailRadioLabel: {
      marginBottom: "4px"
    }
  }) as CSSObject;
